module.exports = __webpack_public_path__ + "static/MRF-logo-copertina-tricolore-2994fb1b7204f73406f7ee50b2d7213b.png";